import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { detectServerPort } from './initServer';

const initApp = async () => {
  try {
    await detectServerPort();
  } catch (error) {
    console.error('API base URL init failed:', error);
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

initApp();

reportWebVitals();
